import { FirebaseTrackingRecord } from '../services/Firebase';

export const RecordTypeMappingToLabel: Record<FirebaseTrackingRecord['type'], string> = {
  addon: 'Addon',
  mega_menu: 'Mega menu',
  section: 'Section',
};
